/**
 * @generated SignedSource<<744519b1b68f3654f447402051e9ba07>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavHeader_query$data = {
  readonly jira: {
    readonly hasWithBoard?: "JiraQuery";
    readonly jiraBoard?: {
      readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_board" | "UserBoardHeader_board">;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_query">;
  readonly " $fragmentType": "NavHeader_query";
};
export type NavHeader_query$key = {
  readonly " $data"?: NavHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "boardId"
    },
    {
      "kind": "RootArgument",
      "name": "withBoard"
    }
  ],
  "kind": "Fragment",
  "name": "NavHeader_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectHeader_query"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "withBoard",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasWithBoard",
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "UserBoardHeader_board"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "HorizontalNavBoardHeader_board"
                      }
                    ],
                    "type": "JiraBoard"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "2b0fa177e4193af217dd2ce99ba40546";

export default node;
